/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantHealthHelpdesk
 */
export interface TenantHealthHelpdesk {
    /**
     * 
     * @type {number}
     * @memberof TenantHealthHelpdesk
     */
    open_threads?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthHelpdesk
     */
    oldest_thread_date?: number;
}

/**
 * Check if a given object implements the TenantHealthHelpdesk interface.
 */
export function instanceOfTenantHealthHelpdesk(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantHealthHelpdeskFromJSON(json: any): TenantHealthHelpdesk {
    return TenantHealthHelpdeskFromJSONTyped(json, false);
}

export function TenantHealthHelpdeskFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantHealthHelpdesk {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'open_threads': !exists(json, 'open_threads') ? undefined : json['open_threads'],
        'oldest_thread_date': !exists(json, 'oldest_thread_date') ? undefined : json['oldest_thread_date'],
    };
}

export function TenantHealthHelpdeskToJSON(value?: TenantHealthHelpdesk | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'open_threads': value.open_threads,
        'oldest_thread_date': value.oldest_thread_date,
    };
}

